module.exports = "/_next/static/images/317b86db63162f0a3b0a75ce64cf62c5-group-man-building@2x.jpg";